import React, { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PROJECTS } from "./projectsData";
import "../Css/Projects.css";

// Standalone page for a single project, e.g. /projects/kpi-dashboard
export function ProjectPage() {
    const { slug } = useParams();
    const project = PROJECTS.find(p => p.slug === slug);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!project) {
        return <Navigate to="/projects" replace />;
    }

    const Component = project.component;
    const index = PROJECTS.indexOf(project);
    const next = PROJECTS[(index + 1) % PROJECTS.length];

    return (
        <div className="project-page" style={{ "--project-accent": project.accent } as React.CSSProperties}>
            <div className="project-page-head">
                <Button component={Link} to="/projects" startIcon={<ArrowBackIcon />} className="project-link">
                    All projects
                </Button>
                <div>
                    <h1>{project.title}</h1>
                    <p>{project.tagline}</p>
                </div>
            </div>
            <div className="project-page-body">
                <Component />
            </div>
            <div className="project-page-next">
                <span>Next project</span>
                <Link to={`/projects/${next.slug}`}>{next.title} →</Link>
            </div>
        </div>
    );
}
